// Footer wordmark: hydrogen bubbles rise from below and settle into NORD (the real logo letters) with the bar
// under it. The letters are a spring system: the pointer (mouse or finger) stirs the bubbles like water, they
// swirl around the hand and then swim back.
// Runs only while the footer is on screen; reduced motion gets the finished wordmark, still.
(() => {
  const wrap = document.querySelector(".foot-mark");
  if (!wrap) return;
  const cv = wrap.querySelector("canvas");
  const ctx = cv.getContext("2d");
  const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
  // white, like Nord's own logo animation, with a faint ice tint in some bubbles
  const COLORS = ["#ffffff", "#ffffff", "#ffffff", "#f3f6ff", "#e4ecff", "#cfdcff"];
  const logo = new Image();
  let W = 0, H = 0, dpr = 1, P = [], ambient = [], sprites = {}, running = false, started = false, raf = 0, t0 = 0;
  const ptr = { x: -1e4, y: -1e4, vx: 0, vy: 0, lx: 0, ly: 0, on: false };

  // one soft glowing dot per colour, drawn once and stamped many times
  const sprite = (c) => {
    const s = document.createElement("canvas"), r = 16;
    s.width = s.height = r * 2;
    const g = s.getContext("2d"), gr = g.createRadialGradient(r, r, 0, r, r, r);
    gr.addColorStop(0, c); gr.addColorStop(0.28, c); gr.addColorStop(0.42, c + "66"); gr.addColorStop(1, c + "00");
    g.fillStyle = gr; g.fillRect(0, 0, r * 2, r * 2);
    return s;
  };

  // the NORD letters cut out of the real logo (top 72%, without the bar and HYDROGEN), measured once
  let glyphs = null;
  const cutGlyphs = () => {
    const s = document.createElement("canvas"), g = s.getContext("2d"), sw = 1200, sh = Math.round(sw * 55.02 / 205.93);
    s.width = sw; s.height = sh; g.drawImage(logo, 0, 0, sw, sh);
    const d = g.getImageData(0, 0, sw, sh).data, lim = Math.round(sh * 0.72);
    let x0 = sw, x1 = 0, y0 = sh, y1 = 0;
    for (let y = 0; y < lim; y++) for (let x = 0; x < sw; x++) if (d[(y * sw + x) * 4 + 3] > 110) {
      if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
    }
    glyphs = { img: s, x: x0, y: y0, w: x1 - x0 + 1, h: y1 - y0 + 1 };
  };

  const targets = () => {
    // draw NORD + a bar under the whole word off screen, then sample it into points
    const o = document.createElement("canvas"), g = o.getContext("2d");
    o.width = W; o.height = H;
    g.fillStyle = "#fff";
    let gw = W * 0.86, gh = gw * glyphs.h / glyphs.w;
    const barGap = 0.2, barH = 0.24;  // relative to the letter height, as in the logo
    if (gh * (1 + barGap + barH) > H * 0.86) { gh = (H * 0.86) / (1 + barGap + barH); gw = gh * glyphs.w / glyphs.h; }
    const gx = (W - gw) / 2, gy = (H - gh * (1 + barGap + barH)) / 2;
    g.drawImage(glyphs.img, glyphs.x, glyphs.y, glyphs.w, glyphs.h, gx, gy, gw, gh);
    g.fillRect(gx, gy + gh * (1 + barGap), gw, gh * barH);
    const data = g.getImageData(0, 0, W, H).data, pts = [];
    const gap = Math.max(4, Math.round(W / 230));
    for (let y = 0; y < H; y += gap)
      for (let x = (y / gap) % 2 ? gap / 2 : 0; x < W; x += gap)
        if (data[(Math.round(y) * W + Math.round(x)) * 4 + 3] > 128) pts.push([x, y]);
    return { pts, gap };
  };

  const build = () => {
    const r = wrap.getBoundingClientRect();
    dpr = Math.min(devicePixelRatio || 1, 2);
    W = Math.round(r.width); H = Math.round(r.height);
    cv.width = W * dpr; cv.height = H * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    const { pts, gap } = targets();
    const old = P;
    P = pts.map(([x, y], i) => {
      const p = old[i];
      const size = gap * (0.36 + Math.random() * 0.26);
      return p && started
        ? Object.assign(p, { tx: x, ty: y, s: size })
        : { tx: x, ty: y, x: x + (Math.random() - 0.5) * W * 0.12, y: H + 20 + Math.random() * H * 1.2,
            vx: 0, vy: 0, s: size, c: COLORS[(Math.random() * COLORS.length) | 0], ph: Math.random() * 6.28,
            d: (x / W) * 0.9 + Math.random() * 0.5 };  // release delay: sweeps left to right
    });
    ambient = Array.from({ length: Math.round(W / 28) }, () => bubble(true));
    if (reduced) { P.forEach((p) => { p.x = p.tx; p.y = p.ty; }); draw(0); }
  };

  const bubble = (anywhere) => ({ x: Math.random() * W, y: anywhere ? Math.random() * H : H + 10,
    s: 1 + Math.random() * 2.4, v: 0.25 + Math.random() * 0.6, ph: Math.random() * 6.28, c: COLORS[(Math.random() * 3) | 0] });

  const step = (time) => {
    const t = (time - t0) / 1000;
    const R = Math.max(70, W * 0.07), R2 = R * R;
    for (const p of P) {
      if (t < p.d) {  // still a free bubble rising from below
        p.y -= 1.6 + p.s * 0.2; p.x += Math.sin(t * 3 + p.ph) * 0.5;
        continue;
      }
      // spring home, with a slow shimmer so the word keeps breathing
      const hx = p.tx + Math.sin(t * 1.3 + p.ph) * 0.6, hy = p.ty + Math.cos(t * 1.1 + p.ph) * 0.6;
      p.vx += (hx - p.x) * 0.04; p.vy += (hy - p.y) * 0.04;
      const dx = p.x - ptr.x, dy = p.y - ptr.y, d2 = dx * dx + dy * dy;
      if (d2 < R2) {
        const d = Math.sqrt(d2) || 1, f = (1 - d / R) ** 2;
        p.vx += (dx / d) * f * 3.5 + (-dy / d) * f * 7 + ptr.vx * f * 0.3;
        p.vy += (dy / d) * f * 3.5 + (dx / d) * f * 7 + ptr.vy * f * 0.3;
      }
      p.vx *= 0.86; p.vy *= 0.86;
      p.x += p.vx; p.y += p.vy;
    }
    for (const b of ambient) {
      b.y -= b.v; b.x += Math.sin(t * 1.5 + b.ph) * 0.25;
      if (b.y < -10) Object.assign(b, bubble(false));
    }
    ptr.vx *= 0.8; ptr.vy *= 0.8;
  };

  const draw = () => {
    ctx.clearRect(0, 0, W, H);
    // loose bubbles as thin rings, as in the logo film
    ctx.strokeStyle = "#ffffff"; ctx.lineWidth = 1;
    for (const b of ambient) {
      ctx.globalAlpha = 0.35 * Math.min(1, b.y / H + 0.2);
      ctx.beginPath(); ctx.arc(b.x, b.y, b.s * 1.4, 0, 6.2832); ctx.stroke();
    }
    ctx.globalAlpha = 1;
    for (const p of P) {
      const s = p.s * 3.2;
      ctx.drawImage(sprites[p.c], p.x - s / 2, p.y - s / 2, s, s);
    }
    ctx.globalAlpha = 1;
  };

  const loop = (time) => { step(time); draw(); raf = running ? requestAnimationFrame(loop) : 0; };
  const start = () => {
    if (running || reduced) return;
    if (!started) { started = true; t0 = performance.now(); }
    running = true; raf = requestAnimationFrame(loop);
  };
  const stop = () => { running = false; cancelAnimationFrame(raf); };

  const move = (e) => {
    const r = cv.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
    if (ptr.on) { ptr.vx = x - ptr.lx; ptr.vy = y - ptr.ly; }
    ptr.x = ptr.lx = x; ptr.y = ptr.ly = y; ptr.on = true;
  };
  const leave = () => { ptr.x = ptr.y = -1e4; ptr.on = false; };

  const init = () => {
    COLORS.forEach((c) => (sprites[c] = sprite(c)));
    build();
    if (reduced) return;
    cv.addEventListener("pointermove", move);
    cv.addEventListener("pointerdown", move);
    cv.addEventListener("pointerleave", leave);
    cv.addEventListener("pointercancel", leave);
    cv.addEventListener("pointerup", (e) => { if (e.pointerType !== "mouse") leave(); });
    new IntersectionObserver(([en]) => (en.isIntersecting ? start() : stop()), { rootMargin: "80px" }).observe(wrap);
    let rt;
    addEventListener("resize", () => { clearTimeout(rt); rt = setTimeout(() => { if (Math.abs(wrap.clientWidth - W) > 2) build(); }, 150); });
  };

  // the letters come from the footer's own logo file, so the Shopify asset URL is always right
  const src = document.querySelector(".logo-foot img, .logo img");
  if (!src) return;
  logo.onload = () => { cutGlyphs(); init(); };
  logo.src = src.currentSrc || src.src;
})();
